import React from "react";
import { Box, Text, Link, Flex, useColorModeValue } from "@chakra-ui/react";
import { RiGithubFill, RiLinkedinBoxFill, RiCodeSSlashFill } from "react-icons/ri";

const Footer = () => {
  const footerBgColor = useColorModeValue("gray.100", "gray.700");

  return (
    <Box bg={footerBgColor} py={4}>
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        maxW="container.lg"
        mx="auto"
        px={4}
      >
        <Text fontSize="sm" color="gray.500">
          &copy; 2023 Ritesh Kr. Shukla. All rights reserved.
        </Text>
        <Flex alignItems="center">
          <Link
            mr={14}
            fontSize="lg"
            color="gray.500"
            href="https://github.com/RiteshKumarShukla"
            target="_blank"
            rel="noopener noreferrer"
            _hover={{ color: "blue" }}
          >
            <RiGithubFill />{" "}
            <Text ml={-4} fontWeight="medium">
              GitHub
            </Text>
          </Link>
          <Link
            mr={14}
            fontSize="lg"
            color="gray.500"
            href="https://www.linkedin.com/in/riteshkrshukla/"
            target="_blank"
            rel="noopener noreferrer"
            _hover={{ color: "red" }}
          >
            <RiLinkedinBoxFill />{" "}
            <Text ml={-5} fontWeight="medium">
              LinkedIn
            </Text>
          </Link>
          <Link
            mr={14}
            fontSize="lg"
            color="gray.500"
            href="https://riteshkumarshukla.github.io/"
            target="_blank"
            rel="noopener noreferrer"
            _hover={{ color: "green" }}
          >
            <RiCodeSSlashFill/>{" "}
            <Text ml={-5} fontWeight="medium">
              Portfolio
            </Text>
          </Link>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Footer;
